/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable security/detect-non-literal-fs-filename */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-unresolved */
/* eslint-disable react-perf/jsx-no-new-function-as-prop */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useState } from 'react'
import { IcoMoon, ToolTipQuestionIconWmo } from '@usap/uicomponents'
import WhatsCoveredDrawer from '@usap/carparts/src/shared/components/ShoppingCartV2/components/Items/Item/ProductProtection/WhatsCoveredDrawer'
import trackEppWhatsCoveredTooltip from '@usap/carparts/src/shared/components/ProductProtectionPlan/gtm/trackEppWhatsCoveredTooltip'
import { useLocation } from 'react-router'
import trackCartProductProtectionWhatIsCoveredClose from '@usap/carparts/src/shared/components/ProductProtectionPlan/gtm/trackCartProductProtectionWhatIsCoveredClose'
import trackProductProtectionWhatIsCoveredMoreDetialsLink from '@usap/carparts/src/shared/components/ProductProtectionPlan/gtm/trackProductProtectionWhatIsCoveredMoreDetailsLink'
import {
  StyledEppContainer,
  StyledEppInnerContainer,
  StyledEppRightContainer,
  StyledEppDivX,
  StyledEppLeftContainer,
  StyledEppExtendTextContainer,
  StyledEppExtendText,
  StyledEppExtendPlan,
  StyledEppSubtext,
} from './ProductProtectionPlan.css'

const ProductProtectionPlan = ({
  year,
  amount,
  eppSubtextMsg,
  isEppSubtext,
  desktopMode,
  eachAmount,
  whatsCoveredDrawerApiData,
  selectedEpp,
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  const handleDrawerOpen = useCallback(() => {
    setIsDrawerOpen(true)
  }, [])

  const location = useLocation()
  const pageTypes = location.pathname
  const pageTypeSplit = pageTypes.split('/')
  const pageType = pageTypeSplit[pageTypeSplit.length - 1]

  const handleDrawerClose = useCallback(() => {
    trackCartProductProtectionWhatIsCoveredClose({
      product: {
        part: {
          name: whatsCoveredDrawerApiData?.partname,
        },
        sku: whatsCoveredDrawerApiData?.sku,
      },
    }, pageType)
    setIsDrawerOpen(false)
  }, [pageType, whatsCoveredDrawerApiData?.partname, whatsCoveredDrawerApiData?.sku])

  const dataTestId = `${pageType}-epp-widget`

  const isConfirmationOrOrderDetailsPage =
    pageTypes.includes('confirmation') ||
    pageTypes.includes('orderdetails') ||
    pageTypes.includes('trackorder')

  const handleToolTipClick = useCallback(() => {
    trackEppWhatsCoveredTooltip()

    if (isConfirmationOrOrderDetailsPage) {
      window.open(selectedEpp?.url, '_blank', 'noopener noreferrer')
    } else {
      handleDrawerOpen()
    }
  }, [isConfirmationOrOrderDetailsPage, selectedEpp?.url, handleDrawerOpen])

  const selectedPlanId = whatsCoveredDrawerApiData?.productProtection?.planId
  const findUrlByProductProtectionPlanId = planId => {
    if (!planId) {
      const defaultPlan = whatsCoveredDrawerApiData?.productProtectionPlans[0]
      return defaultPlan?.url
    }

    const protectionPlan = whatsCoveredDrawerApiData?.productProtectionPlans?.find(
      plan => plan?.code === planId,
    )
    return protectionPlan?.url
  }
  const detailsAndFaqUrl = findUrlByProductProtectionPlanId(selectedPlanId)
  const handleDetailsAndFaqVisit = () => {
    trackProductProtectionWhatIsCoveredMoreDetialsLink(
      {
        product: {
          part: {
            name: whatsCoveredDrawerApiData?.partname,
          },
          sku: whatsCoveredDrawerApiData?.sku,
        },
        url: detailsAndFaqUrl,
      },
      pageType,
    )
    window.open(detailsAndFaqUrl, '_blank', 'noopener noreferrer')
  }

  return (
    <StyledEppContainer
      className={desktopMode ? 'desktop-mode' : 'mobile-mode'}
      data-testid={dataTestId}
    >
      <StyledEppInnerContainer>
        <StyledEppRightContainer>
          <StyledEppDivX />
        </StyledEppRightContainer>
        <StyledEppLeftContainer>
          <StyledEppExtendTextContainer>
            <StyledEppExtendText>Extend Product Protection</StyledEppExtendText>
            <div onClick={handleToolTipClick}>
              <IcoMoon icon={ToolTipQuestionIconWmo} />
            </div>
          </StyledEppExtendTextContainer>
          <WhatsCoveredDrawer
            isOpen={isDrawerOpen}
            handleDrawerClose={handleDrawerClose}
            drawerApiData={whatsCoveredDrawerApiData}
            handleDetailsAndFaqVisit={handleDetailsAndFaqVisit}
          />
          <StyledEppExtendPlan>
            {`${year} Protection Plan - $${amount} ${eachAmount}`}
          </StyledEppExtendPlan>
          {isEppSubtext && (
            <StyledEppSubtext data-testid="checkout-epp-subtext">
              {eppSubtextMsg}
            </StyledEppSubtext>
          )}
        </StyledEppLeftContainer>
      </StyledEppInnerContainer>
    </StyledEppContainer>
  )
}

export default ProductProtectionPlan
